export default "__VITE_ASSET__f3ef403e__"